import React from "react";
import styled from "styled-components";
import FunctionalPage from "./FunctionalPage";
import notFoundSVG from '../images/404.svg'
import GoHomeButton from "../components/buttons/GoHomeButton";


export const NotFound = () => {
    return (
        <Page>
            <IMG>
                <img src={notFoundSVG} alt="Cette page n'existe pas !"/>
            </IMG>
            <RightSection>
                <Tag>
                    <p> Page non trouvée </p>
                </Tag>
                <h1> Oh Non ! Erreur 404</h1>
                <h2> Cette page n'existe pas.<br/> Vous pouvez retourner à la page d'accueil.</h2>
                <GoHomeButton/>
            </RightSection>
        </Page>
    )
}

const NotFoundPage = () => {
    return (
        <FunctionalPage
            component={<NotFound/>}
        />
    )
}


const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 10rem);
  gap: 1rem;
  width: 100%;
  color: var(--color-black);
  align-items: center;

  h1 {
    font-size: 3rem;
  }

  h2 {
    font-size: 1.75rem;
    color: var(--color-purple-06);
    font-weight: 600;
  }

  @media (min-width: 900px) {
    flex-direction: row;
  }
`

const IMG = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  order: 1;
  height: 70%;

  img {
    width: 80%;
  }

  @media (min-width: 900px) {
    align-items: unset;
    order: 0;
  }
`
const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 70%;
  align-items: center;
  padding: 2rem 4rem;

  .go-home-btn {
    order: 0;
  }

  @media (min-width: 900px) {
    align-items: flex-start;
    justify-content: flex-start;
  }
`

const Tag = styled.div`
  background-color: var(--color-purple-lighten);
  padding: 0.5rem 1rem;
  border-radius: 15px;

  p {
    text-align: center;
    font-weight: 600;
  }
`
export default NotFoundPage